module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1276.52040e37.jpg";